export default __webpack_public_path__ + "media/zurb/img/playground/figma-logo-img-efc94ae0c952e278b8950b6803633de9.png";